// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.savedcards.CardPayload
import org.mifospay.core.model.savedcards.SavedCard

@OptIn(InternalKtorfitApi::class)
public class _SavedCardServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : SavedCardService {
  override fun getSavedCards(clientId: Long): Flow<List<SavedCard>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "datatables/saved_cards/${"$clientId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<SavedCard>>>(),)!! 
  }

  override fun getSavedCard(clientId: Long, cardId: Long): Flow<List<SavedCard>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "datatables/saved_cards/${"$clientId".encodeURLPath()}/${"$cardId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<SavedCard>>>(),)!! 
  }

  override suspend fun addSavedCard(clientId: Long, card: CardPayload) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "datatables/saved_cards/${"$clientId".encodeURLPath()}")
        }
        setBody(card) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun updateCard(
    clientId: Long,
    cardId: Long,
    card: CardPayload,
  ) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "datatables/saved_cards/${"$clientId".encodeURLPath()}/${"$cardId".encodeURLPath()}")
        }
        setBody(card) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun deleteCard(clientId: Long, cardId: Long) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "datatables/saved_cards/${"$clientId".encodeURLPath()}/${"$cardId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }
}

public class _SavedCardServiceProvider : ClassProvider<SavedCardService> {
  override fun create(_ktorfit: Ktorfit): SavedCardService = _SavedCardServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createSavedCardService(): SavedCardService = _SavedCardServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
